class ProductDiscountPrice {
  constructor(section) {
    this.section = section;
    this.message = section.querySelector(
      '[data-product-discount-message]'
    );
    this.price = section.querySelector(
      '[data-product-discount-price]'
    );
    this.variantsData = section.querySelector(
      '[data-product-discount-variants]'
    );

    if (!this.message || !this.price || !this.variantsData) return;

    this.discountPercentage = Number(
      this.message.dataset.discountPercentage || 0
    );

    if (this.discountPercentage <= 0) return;

    try {
      this.variants = JSON.parse(this.variantsData.textContent);
    } catch (error) {
      console.error('Discount variants JSON error:', error);
      return;
    }

    this.lastVariantId = null;

    this.handleVariantChange =
      this.handleVariantChange.bind(this);

    this.init();
  }

  init() {
    this.updateFromCurrentVariant();

    this.section.addEventListener(
      'change',
      this.handleVariantChange
    );

    this.section.addEventListener(
      'input',
      this.handleVariantChange
    );

    this.observer = new MutationObserver(() => {
      this.updateFromCurrentVariant();
    });

    this.observer.observe(this.section, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'value',
        'checked',
        'selected'
      ]
    });
  }

  handleVariantChange() {
    window.requestAnimationFrame(() => {
      this.updateFromCurrentVariant();
    });
  }

  getVariantInput() {
    return (
      this.section.querySelector(
        'form[action*="/cart/add"] input[name="id"]'
      ) ||
      this.section.querySelector(
        'input[name="id"]'
      )
    );
  }

  updateFromCurrentVariant() {
    const variantInput = this.getVariantInput();

    if (!variantInput?.value) return;

    const variantId = String(variantInput.value);

    if (variantId === this.lastVariantId) return;

    const variant = this.variants.find(
      (item) => String(item.id) === variantId
    );

    if (!variant) return;

    this.lastVariantId = variantId;

    const discountedPrice = Math.round(
      Number(variant.price) *
        ((100 - this.discountPercentage) / 100)
    );

    this.price.innerHTML =
      this.formatMoney(discountedPrice);

    this.message.hidden = variant.available === false;
  }

  formatMoney(cents) {
    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function'
    ) {
      return window.Shopify.formatMoney(cents);
    }

    if (
      window.Currency &&
      typeof window.Currency.formatMoney === 'function'
    ) {
      return window.Currency.formatMoney(cents);
    }

    const currency =
      window.Shopify?.currency?.active || 'EUR';

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'el-GR',
        {
          style: 'currency',
          currency
        }
      ).format(Number(cents) / 100);
    } catch (error) {
      return `${(Number(cents) / 100).toFixed(2)} €`;
    }
  }

  destroy() {
    this.section.removeEventListener(
      'change',
      this.handleVariantChange
    );

    this.section.removeEventListener(
      'input',
      this.handleVariantChange
    );

    this.observer?.disconnect();
  }
}

const initializeProductDiscountPrices = (
  container = document
) => {
  container
    .querySelectorAll('[data-product-discount-section]')
    .forEach((section) => {
      if (section.dataset.discountPriceInitialized === 'true') {
        return;
      }

      section.dataset.discountPriceInitialized = 'true';
      section.productDiscountPrice =
        new ProductDiscountPrice(section);
    });
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => initializeProductDiscountPrices(),
    { once: true }
  );
} else {
  initializeProductDiscountPrices();
}

document.addEventListener(
  'shopify:section:load',
  (event) => {
    initializeProductDiscountPrices(event.target);
  }
);

document.addEventListener(
  'shopify:section:unload',
  (event) => {
    const section = event.target.querySelector(
      '[data-product-discount-section]'
    );

    section?.productDiscountPrice?.destroy();
  }
);